import { Loader2, RefreshCw } from 'lucide-react'
import { Button } from '../ui/button'
import TurnstileWidget from './TurnstileWidget'
import type { useEmailCodeVerification } from '../../hooks/useEmailCodeVerification'

export default function EmailCodeVerification({
  verification,
}: {
  verification: ReturnType<typeof useEmailCodeVerification>
}) {
  if (!verification.siteKey) return null
  return (
    <div
      data-testid="email-code-verification"
      className="mb-4 w-full min-w-0 space-y-2"
    >
      {verification.sending ? (
        <div role="status" className="flex min-h-16 items-center gap-2 text-sm">
          <Loader2 size={16} className="animate-spin" />
          正在發送驗證碼
        </div>
      ) : verification.completed ? (
        <div
          role="status"
          className="flex items-center justify-between gap-2 rounded-lg border border-green-200 bg-green-50 p-3 text-sm text-green-800"
        >
          人機驗證已完成
          <Button
            variant="ghost"
            size="icon"
            title="重新驗證以再次獲取驗證碼"
            aria-label="重新驗證"
            onClick={verification.reset}
          >
            <RefreshCw size={16} />
          </Button>
        </div>
      ) : (
        <TurnstileWidget
          ref={verification.widgetRef}
          siteKey={verification.siteKey}
          action="email_code"
          onTokenChange={verification.setToken}
          onErrorChange={verification.setError}
        />
      )}
      {verification.error && (
        <p
          role="alert"
          className="rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-800"
        >
          {verification.error}
        </p>
      )}
    </div>
  )
}
